import React, { useState } from 'react';
import Media from '../../partials/Media/index.js';
import './OmniTabs.scss';
import DogEar from '../../partials/DogEar/DogEar.js';
import Tabs from '../../partials/Tabs/index.js';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import Button from '../../partials/Button';
import Scroll from '../../partials/Scroll/Scroll.jsx';
import Instructions from '../../partials/Instructions/Instructions';


const HorizontalTabs = props => {


    const [activeMainTab, setActiveMainTab] = useState('activity');
    const [progress, setProgress] = useState(0);
    const [toolboxIsOpen, setToolboxIsOpen] = useState(false);
    // const [introComplete, setIntroComplete] = useState(false);


    return (

        <div className="ot-grid-container">
            <div className="back-btn-container">
                <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
            </div>
            <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
                <Instructions body={props.data.config.instruction} />
                <div className="border-container">
                    <div className="horizontal-tabs">
                        {
                            // introComplete && 
                            activeMainTab === 'activity' && <div className="activity-container">
                                {/* <div className='instructions'>{props.data.config.instruction}</div> */}
                                <div className={`tabs-direction-${props.tabDirection}`}>


                                    <Tabs tabsArray={props.data.activity.subTabs}
                                        onProgress={setProgress}
                                        tabComponent={props => <DogEar onClick={props.onClick} length={props.length} selected={props.selected} index={props.tabIndex} visited={props.visited} >
                                            {props.tabIcon && <img src={props.tabIcon} />} {props.tabText} {props.visited && <div className='check' />}
                                        </DogEar>}
                                        tabContentComponent={(activeSubTab) => {
                                            return <div className='tab-content-container'>

                                                <div className='tab-content-header'>
                                                    <div className='header-text'>
                                                        {activeSubTab.hdng}
                                                    </div>
                                                    <div className='toolbox' onClick={() => setToolboxIsOpen(true)}>
                                                        <img src={'media/img/icons/gears.svg'} />
                                                    </div>
                                                </div>

                                                {(() => {
                                                    if (activeSubTab.layoutType === 'image-only') {
                                                        return <Media src={activeSubTab.img} />
                                                    }
                                                    if (activeSubTab.layoutType === 'image-text') {
                                                        return <div className='ot-flex-container'>
                                                            <div className='left-ot-container'>
                                                                <ImageWithOptionalOverlayText data={activeSubTab.img} />
                                                            </div>
                                                            <Scroll>
                                                                <div className='right-ot-container'>
                                                                    <p className='ot-text-content' dangerouslySetInnerHTML={{ __html: activeSubTab.text }}></p>
                                                                </div>
                                                            </Scroll>
                                                        </div>
                                                    }
                                                    if (activeSubTab.layoutType === 'image-text-audio') {
                                                        return <div className='ot-flex-container'>
                                                            <div className='left-ot-container'>
                                                                <p className='ot-text-content' dangerouslySetInnerHTML={{ __html: activeSubTab.text }}></p>
                                                                <Media {...activeSubTab.audio} />
                                                            </div>
                                                            <div className='right-ot-container'>
                                                                <ImageWithOptionalOverlayText data={activeSubTab.img} />
                                                            </div>
                                                        </div>
                                                    }
                                                })()}
                                            </div>

                                        }} />
                                </div>
                            </div>
                        }
                        {/* wrap the button "tab" inside a container to make the css :only-of-type selector work*/}
                        {activeMainTab == 'activity' &&
                            <div className="btn-container">
                                <Button
                                    text={props.data?.config?.continueBtnText}
                                    variant="toRight"
                                    disabled={progress == 1 ? false : true}
                                    className={"global-button mt-2"}
                                    onClick={() => { props.onComplete() }} />
                            </div>
                        }
                    </div>
                </div>
            </InteractionContainer>
        </div>
    );
    //

};





const ImageWithOptionalOverlayText = (props) => {
    // const imageTag = useRef();
    const [imageWidth, setImageWidth] = useState(100);
    const [imageHeight, setImageHeight] = useState(100);

    const measureVerticalPaddingAndMarginAssumingPixels = (e) => {
        const computedStyle = window.getComputedStyle(e);
        return [
            computedStyle.marginTop,
            computedStyle.marginBottom,
            computedStyle.paddingTop,
            computedStyle.paddingBottom
        ].reduce((accumulator, stringValue) => {
            const pixelsValue = Number(stringValue.replace("px", ""));
            if (pixelsValue == NaN) {
                throw new Error("Error: the margin and padding of " + e + " must be defined in pixels.");
            }
            return accumulator + pixelsValue;
        }, 0);
    };

    // I wasn't able to figure out  a way to get the layout engine to do this for us w/ css, while also having the overlay scrim
    // show up on top of the image properly. This is a bit of a hack to just set it to a fixed size after the image loads. 
    const onImageLoaded = (event) => {
        const aspectRatio = event.target.naturalWidth / event.target.naturalHeight;
        const overlayParent = event.target.parentElement;
        if (overlayParent && overlayParent.parentElement) {

            const verticalPaddingTotal = measureVerticalPaddingAndMarginAssumingPixels(event.target) + measureVerticalPaddingAndMarginAssumingPixels(overlayParent);
            const containerHeight = overlayParent.parentElement.clientHeight;
            const imageHeightToFitContainer = containerHeight - verticalPaddingTotal;
            setImageWidth(imageHeightToFitContainer * aspectRatio);
            setImageHeight(imageHeightToFitContainer);
        }
    }
    const fixedSize = { width: `${imageWidth}px`, height: `${imageHeight}px` };

    return <div className="image-with-optional-overlay-text" style={fixedSize}>
        <img src={props.data.src} onLoad={onImageLoaded} style={fixedSize} />
        {props.data.overlayText && <div className="overlay-text" style={fixedSize}>{props.data.overlayText}</div>}
    </div>;
};




export default HorizontalTabs;